/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import {
  getOverrideProps,
  getOverridesFromVariants,
  mergeVariantsAndOverrides,
} from "@aws-amplify/ui-react/internal";
import { Flex, Text } from "@aws-amplify/ui-react";
export default function CommonBtnBlue(props) {
  const { overrides: overridesProp, ...rest } = props;
  const variants = [
    {
      overrides: { text: {}, CommonBtnBlue: {} },
      variantValues: { situation: "default", size: "large" },
    },
    {
      overrides: {
        text: { lineHeight: "14px", width: "unset" },
        CommonBtnBlue: {},
      },
      variantValues: { situation: "situation4", size: "small" },
    },
    {
      overrides: {
        text: {},
        CommonBtnBlue: { backgroundColor: "rgba(0,140,230,1)" },
      },
      variantValues: { situation: "hover", size: "large" },
    },
    {
      overrides: {
        text: { lineHeight: "14px", width: "unset" },
        CommonBtnBlue: { backgroundColor: "rgba(0,140,230,1)" },
      },
      variantValues: { situation: "situation3", size: "small" },
    },
  ];
  const overrides = mergeVariantsAndOverrides(
    getOverridesFromVariants(variants, props),
    overridesProp || {}
  );
  return (
    <Flex
      gap="10px"
      direction="row"
      width="unset"
      height="unset"
      justifyContent="center"
      alignItems="center"
      position="relative"
      borderRadius="8px"
      padding="10px 24px 10px 24px"
      backgroundColor="rgba(0,153,255,1)"
      display="flex"
      {...rest}
      {...getOverrideProps(overrides, "CommonBtnBlue")}
    >
      <Text
        fontFamily="Noto Sans"
        fontSize="14px"
        fontWeight="600"
        color="rgba(255,255,255,1)"
        lineHeight="25.760000228881836px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="0.55px"
        width="160px"
        height="unset"
        gap="unset"
        alignItems="unset"
        shrink="0"
        position="relative"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="button"
        {...getOverrideProps(overrides, "text")}
      ></Text>
    </Flex>
  );
}
